module.exports = __webpack_public_path__ + "static/media/rewards.25119397.svg";